import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AppStoreProvider } from "./store/AppStore";
import { AuthProvider } from "./lib/auth";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <AppStoreProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </AppStoreProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;